import * as Yup from 'yup';

export const validationSchemaFormCards = Yup.object({
  cardNumber: Yup.string().required('Поле обязательно для заполнения'),
  holderName: Yup.string().required('Поле обязательно для заполнения'),
});
